import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Modal } from "reactstrap";
import {
  deleteOneMembership,
  getMembershipList,
} from "../../../redux/membership/action";
import { useNavigate } from "react-router-dom";
import CardHeader from "../../Common/CardHeader/CardHeader";
import search from "../../assets/images/search-lg.svg";
import {
  deleteSection,
  section3ListingData,
  section4ListingData,
  section5ListingData,
  sectionfaqListingData,
} from "../../../redux/cms/action";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import DeleteCategory from "../Categories/DeleteCategory";

const Sectionfaqlist = () => {
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [modals, setModals] = useState(false);
  const [currentComponent, setCurrentComponent] = useState({});

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openFilter, setOpenFilter] = useState(false);

  const [params, setParams] = useState({
    section: 7,
    page: 1,
  });
  const section5data = useSelector(
    (state) => state?.reusableSlice?.getfaqlisting
  );
  console.log(section5data, "section5data");
  useEffect(() => {
    dispatch(sectionfaqListingData(params));
  }, [dispatch, params]);

  const addComponent = () => {
    navigate("/sectionfaqadd");
  };
  const updateComponent = (id) => {
    navigate(`/sectionfaqupdate/${id}`);
  };

  const deleteComponent = () => {
    if (currentComponent && currentComponent.id) {
      dispatch(deleteSection(currentComponent?.id));
    } else {
      console.error("No valid ID found for the component to delete.");
    }
  };

  return (
    <div className="p-3">
      <div className="category-wrapper">
        <div className="d-flex align-items-center justify-content-between pb-3 ">
          <h4>FAQS</h4>
          <button
            className="background-button"
            onClick={() => {
              addComponent();
            }}
          >
            <span>Add</span>
          </button>
        </div>
        {/* <CardHeader
        params={params}
        setParams={setParams}
        addmodel={addComponent}
        search={search}
        setOpenFilter={setOpenFilter}
        modals={modals}
        setModals={setModals}
      /> */}
        <CardBody className="table-sec px-0">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Title</th>
                <th scope="col">Sub Title</th>
                <th scope="col">Position</th>
                <th scope="col" className="text-center">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {section5data?.cms?.length > 0 ? (
                section5data?.cms?.map((item, index) => (
                  <tr key={index}>
                    <td> {index + 1 + (params?.page - 1) * 10}</td>
                    <td>{item?.title} </td>
                    <td>{item?.sub_title} </td>
                    <td>{item?.position} </td>

                    <td>
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ columnGap: "10px" }}
                      >
                        <button
                          className="border-button"
                          onClick={() => updateComponent(item?.id)}
                        >
                          <span>Update</span>
                        </button>
                        <button
                          className="background-button"
                          onClick={() => {
                            setModal(true);
                            setCurrentComponent(item);
                          }}
                        >
                          <span>Delete</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </CardBody>
        <CommonPagination
          params={params}
          setParams={setParams}
          pagination_meta={section5data?.pagination_meta}
        />
        <Modal isOpen={modal} toggle={() => setModal((state) => !state)}>
          <DeleteCategory
            modalTitle={"cms"}
            setModal={setModal}
            currentComponent={currentComponent}
            deleteComponent={deleteComponent}
          ></DeleteCategory>
        </Modal>
      </div>
    </div>
  );
};

export default Sectionfaqlist;

